module.exports = __webpack_public_path__ + "img/scan1.526b564c.png";